import { render, staticRenderFns } from "./queue-summary-table.vue?vue&type=template&id=e616d99c&"
import script from "./queue-summary-table.vue?vue&type=script&lang=js&"
export * from "./queue-summary-table.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports